import { DownloadSimple } from '@phosphor-icons/react'

import TextField from '../../../../components/FormLegacy/FormFieldsV2/TextField'
import TextAreaField from '../../../../components/FormLegacy/FormFieldsV2/TextAreaField'
import RadioField from '../../../../components/FormLegacy/FormFieldsV2/RadioField'
import CheckboxField from '../../../../components/FormLegacy/FormFieldsV2/CheckboxField'
import { getAssetLink } from '../../../../helpers/get-asset-link'

const handleDownload = async (fileName) => {
  const link = getAssetLink({ path: 'chitown-images/checklist-attachments', file: fileName })
  try {
    const response = await fetch(link)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = fileName
    document.body.appendChild(anchor)
    anchor.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(anchor)
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error)
  }
}

export const getProperComponent = (inputData, currentNestedNum = null, t) => {
  const isNestedAvailable = currentNestedNum !== null
  const nestedFormCount = isNestedAvailable
    ? 0
    : inputData.formItems.length && inputData.formItems[0].answers
      ? inputData.formItems[0].answers?.length
      : 0

  switch (inputData.inputType) {
    case 'short_answer':
      return (
        <div key={inputData.id} className="text-answer-component">
          <TextField
            name="short-answer"
            label={`${inputData.taskLabel}${inputData.isRequired ? '*' : ''}`}
            value={
              inputData.answers
                ? isNestedAvailable
                  ? inputData.answers[currentNestedNum][0]
                  : inputData.answers[0]
                : ''
            }
            disabled
          />
        </div>
      )
    case 'long_answer':
      return (
        <div key={inputData.id} className="text-answer-component">
          <TextAreaField
            name="long-answer"
            label={`${inputData.taskLabel}${inputData.isRequired ? '*' : ''}`}
            value={
              inputData.answers
                ? isNestedAvailable
                  ? inputData.answers[currentNestedNum][0]
                  : inputData.answers[0]
                : ''
            }
            disabled
          />
        </div>
      )
    case 'single_choice':
      return (
        <div key={inputData.id} className="single-answer-component">
          <div className="task-label">
            {inputData.taskLabel}
            {inputData.isRequired ? '*' : null}
          </div>
          {inputData.options.map((radioInput) => (
            <RadioField
              key={radioInput}
              label={radioInput}
              checked={
                isNestedAvailable
                  ? radioInput === inputData.answers[currentNestedNum][0]
                  : radioInput === inputData.answers[0]
              }
              disabled
            />
          ))}
        </div>
      )
    case 'multiple_choice':
      return (
        <div key={inputData.id} className="multi-answer-component">
          <div className="task-label">
            {inputData.taskLabel}
            {inputData.isRequired ? '*' : null}
          </div>
          {inputData.options.map((checkboxInput) => (
            <CheckboxField
              name="checkbox-button"
              key={checkboxInput}
              label={checkboxInput}
              readOnly
              value={
                isNestedAvailable
                  ? inputData.answers[currentNestedNum]?.includes(checkboxInput)
                  : inputData.answers?.includes(checkboxInput)
              }
              disabled
            />
          ))}
        </div>
      )
    case 'providers_info':
      return (
        <div key={inputData.id} className="providers-component">
          {inputData.providersInfo.map((provider) => (
            <div key={provider.name} className="provider-container">
              <div className="provider-name">{provider.name}</div>
              {provider.logo ? (
                <img
                  src={getAssetLink({ path: 'chitown-images/checklist', file: provider.logo })}
                />
              ) : (
                <div className="empty-provider-logo">
                  {t('checklists-tasks:inputComponents.noLogo')}
                </div>
              )}
            </div>
          ))}
        </div>
      )
    case 'text_info':
      return (
        <div
          key={inputData.id}
          className="html-text-info-component"
          dangerouslySetInnerHTML={{ __html: inputData.textInfo }}
        />
      )
    case 'file_upload':
      return (
        <div key={inputData.id} className="files-component">
          <div className="task-label">
            {inputData.taskLabel}
            {inputData.isRequired ? '*' : null}
          </div>
          {isNestedAvailable
            ? inputData.answers[currentNestedNum]?.map((fileName) => (
                <div key={fileName} className="file-row" onClick={() => handleDownload(fileName)}>
                  {fileName || '-'}
                  <DownloadSimple size={20} />
                </div>
              ))
            : inputData.answers?.map((fileName) => (
                <div key={fileName} className="file-row" onClick={() => handleDownload(fileName)}>
                  {fileName || '-'}
                  <DownloadSimple size={20} />
                </div>
              ))}
        </div>
      )
    case 'form':
      return (
        <div key={inputData.id} className="nested-forms-component">
          <div className="nested-forms-component__header">
            <h3>{inputData.formActionLabel}</h3>
            <h5>
              {t('checklists-tasks:inputComponents.entriesCount', {
                num: nestedFormCount,
                max: inputData.formMaxEntries,
              })}
            </h5>
          </div>
          {nestedFormCount
            ? [...Array(nestedFormCount).keys()].map((currentNestedNum) => {
                return (
                  <div key={currentNestedNum}>
                    <h4>
                      {inputData.formActionLabel} {currentNestedNum + 1}
                    </h4>
                    {inputData.formItems.map((formItem) => {
                      return getProperComponent(formItem, currentNestedNum, t)
                    })}
                  </div>
                )
              })
            : null}
        </div>
      )
    default:
      return null
  }
}
